import { render, staticRenderFns } from "./CurrencyInput.vue?vue&type=template&id=2d115e0b&scoped=true"
import script from "./CurrencyInput.vue?vue&type=script&lang=js"
export * from "./CurrencyInput.vue?vue&type=script&lang=js"
import style0 from "./CurrencyInput.vue?vue&type=style&index=0&id=2d115e0b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d115e0b",
  null
  
)

export default component.exports